class AccountSectionToggler {
  constructor(targetId, targetClass) {
    this.targetId = targetId;
    this.targetClass = targetClass;
    this.targetElement = document.getElementById(this.targetId);
    this.blocksToHide = document.querySelectorAll(this.targetClass);
    this.navLinks = document.querySelectorAll('a.js-tab-trigger');

    if (!this.targetElement) return;

    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => this.handleHashDisplay());
    window.addEventListener('hashchange', () => this.handleHashDisplay());

    this.navLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        this.navLinks.forEach(nav => nav.classList.remove('active'));
        event.currentTarget.classList.add('active');
      });
    });
  }

  handleHashDisplay() {
    const currentHash = window.location.hash;

    if (`#${this.targetId}` === currentHash) {
      this.hideBlocks();
      this.targetElement.style.display = 'block';
    } else {
      this.showBlocks();
      this.targetElement.style.display = 'none';
    }

    this.highlightActiveTab();
  }

  highlightActiveTab() {
    const currentPath = window.location.pathname + window.location.hash;

    this.navLinks.forEach(link => {
      const href = link.getAttribute('href');
      const fullHref = new URL(href, window.location.origin).pathname + new URL(href, window.location.origin).hash;

      if (currentPath === fullHref) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });
  }

  hideBlocks() {
    this.blocksToHide.forEach(block => {
      block.style.display = 'none';
    });
  }

  showBlocks() {
    this.blocksToHide.forEach(block => {
      block.style.display = 'block';
    });
  }
}

new AccountSectionToggler('my_points', '.hide_block');
